<!--能源损耗（）-->
<template>
<div class="ec commonborder">
  <div id="ec_bar1" class="echarts"></div>
  <!-- <div class="ectitle"><span>低</span><span>中</span><span>高</span></div> -->
  <!-- <div class="eclist" v-for="(item,index) in shdata" :key="index">
    <span>{{item.name}}</span>
    <div><span class="num" :style="'left:'+item.valueleft+'%'">{{item.value}}%</span><span class="di" :style="'width:'+item.minw+'%'"></span><span class="gao" :style="'width:'+item.maxw+'%'"></span></div>
    <span>{{item.text}}</span>
  </div> -->
</div>

</template>

<script>
let echarts = require("echarts/lib/echarts");
import api from '@/apis/power/power';
export default {
  data() {
    return {
      shdata:[//min:最小值，min：最大值，minw：低区域宽度（计算），maxw：高区域宽度（计算），valueleft：值得位置（0%-100%，计算），text：结果文字说明（根据值判断）
        {name:'电力损耗',min:2,max:5,value:3,minw:20,maxw:20,valueleft:30,text:'优秀'},
        {name:'水损耗',min:5,max:10,value:3,minw:20,maxw:20,valueleft:30,text:'优秀'},
        {name:'燃气损耗',min:0.5,max:1,value:0.3,minw:20,maxw:20,valueleft:30,text:'优秀'},
        {name:'煤炭损耗',min:2,max:5,value:0,minw:20,maxw:20,valueleft:30,text:'优秀'},
        {name:'燃油损耗',min:2,max:5,value:0,minw:20,maxw:20,valueleft:30,text:'优秀'},
      ],
    };
  },
  methods: {
    //获取数据
    getList(){
      api.getLoss().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          var power = _data.powerLoss>=100?100:_data.powerLoss
          var water = _data.waterLoss>=100?100:_data.waterLoss
          var gas = _data.gasLoss>=100?100:_data.gasLoss
          var coal = _data.coalLoss>=100?100:_data.coalLoss
          var oil = _data.fuelLoss>=100?100:_data.fuelLoss
          let arr = []
          if(power<=2&&power>=0){
            arr[0]='优秀'
          }else if(power<=5&&power>2){
            arr[0]='良好'
          }else{
            arr[0]='较差'
          }
          if(water<=5&&water>=0){
            arr[1]='优秀'
          }else if(water<=10&&water>5){
            arr[1]='良好'
          }else{
            arr[1]='较差'
          }
          if(gas<=0.5&&gas>=0){
            arr[2]='优秀'
          }else if(gas<=1&&gas>0.5){
            arr[2]='良好'
          }else{
            arr[2]='较差'
          }
          if(coal<=2&&coal>=0){
            arr[3]='优秀'
          }else if(coal<=5&&coal>2){
            arr[3]='良好'
          }else{
            arr[3]='较差'
          }
          if(oil<=2&&oil>=0){
            arr[4]='优秀'
          }else if(oil<=5&&oil>2){
            arr[4]='良好'
          }else{
            arr[4]='较差'
          }
          this.ec_bar1(power,water,gas,coal,oil,arr.reverse())
        }
      })
    },
    ec_bar1(a,b,c,d,e,arr){
      if(a<0)a=0;
      if(b<0)b=0;
      if(c<0)c=0;
      if(d<0)d=0;
      if(e<0)e=0;
      let ec_bar1 = echarts.init( document.getElementById('ec_bar1') );
      ec_bar1.setOption({
          color: ['#1ad38b', '#00fcff', '#ae74f3'],
          title:[
            {
              text: '低',
              x: '18%',
              y: 8,
              textAlign: "center",
              textStyle: {
                fontWeight: "normal",
                fontSize: this.$echartsFontSize,
                color:'#ccd0f2',
                textAlign: "center",
              },
            },
            {
              text: '中',
              x: '52%',
              y: 8,
              textAlign: "center",
              textStyle: {
                fontWeight: "normal",
                fontSize: this.$echartsFontSize,
                color:'#ccd0f2',
                textAlign: "center",
              },
            },
            {
              text: '高',
              x: '85%',
              y: 8,
              textAlign: "center",
              textStyle: {
                fontWeight: "normal",
                fontSize: this.$echartsFontSize,
                color:'#ccd0f2',
                textAlign: "center",
              },
            }
          ],
          grid: {
              bottom: '-10px',top: '20px',left:'20px',right:'20px',
              containLabel: true
          },
          xAxis: {
              show: false,
              type: 'value',
              axisTick: { show: false, },
              axisLine: {
                  show: false
              }
          },
          yAxis: [
            {
              type: 'category',axisLabel:{color:'#fff',fontSize:this.$echartsFontSize},
              axisTick: {
                  show: false
              },
              axisLine: {
                  show: false
              },
              data: ["燃油损耗", "煤碳损耗", "燃气损耗", "水损耗", "电力损耗"]
            },{
              type: 'category',axisLabel:{color:'#ccd0f2',fontSize:this.$echartsFontSize},
              axisTick: {
                  show: false
              },
              axisLine: {
                  show: false
              },
              data:arr
            }
          ],
          series: [{
                  name: '低',
                  type: 'bar',
                  stack: 'Tik Tok',
                  barWidth: '40%',
                  data: [33, 33, 33, 33, 33],
                  
              },
              {
                  name: '中',
                  type: 'bar',
                  stack: 'Tik Tok',
                  barWidth: '40%',
                  data: [33, 33, 33, 33, 33]
              },
              {
                  name: '高',
                  type: 'bar',
                  stack: 'Tik Tok',
                  barWidth: '40%',
                  data: [34, 34, 34, 34, 34]
              },
              {
                  type:'bar',stack: 'Tik Tok',
                  markPoint: {
                      data: [
                          {
                            name:'电力',
                            symbol: 'triangle',
                            symbolSize: this.$echartsFontSize,
                            symbolRotate: 0,//剪头方向
                            // symbolOffset:[a>=5?-70:70,0],
                            // symbolOffset:[20,0],
                            itemStyle: {
                                normal: { color: '#00fcff' }
                            },
                            x:a<=2?(8+a*14.5).toFixed(2)+"%":a<=5?(37+a*5.6).toFixed(2)+"%":(65+a*0.3).toFixed(2)+"%",
                            y: '20%',
                            label: {
                                normal: {
                                    show: true,
                                    formatter:a+"%",
                                    offset:[a>=97?-30:0,-19],
                                    color:'#fff',
                                    fontSize:this.$echartsFontSize, 
                                    fontWeight:600
                                }
                            },
                          },
                          {
                            name:'水',
                              symbol: 'triangle',
                              symbolSize: this.$echartsFontSize,
                              symbolRotate: 0,//剪头方向
                              // symbolOffset:[b>=50?-70:70,0],
                              // symbolOffset:[-5,0],
                              itemStyle: {
                                  normal: {
                                      color: '#00fcff'
                                  }
                              },
                              x:b<=5?(8+b*5.6).toFixed(2)+"%":b<=10?(37+b*2.8).toFixed(2)+"%":(65+b*0.3).toFixed(2)+"%",
                              y: '38.5%',
                              label: {
                                  normal: {
                                      show: true,
                                      formatter:b+"%",
                                      offset:[b>=97?-30:0,-19],
                                      color:'#fff',
                                      fontSize:this.$echartsFontSize, 
                                      fontWeight:600
                                  }
                              },
                          },
                          {
                              name:'燃气',
                              symbol: 'triangle',
                              symbolSize: this.$echartsFontSize,
                              symbolRotate: 0,//剪头方向
                              // symbolOffset:[c>=50?-70:70,0],
                              // symbolOffset:[70,0],
                              itemStyle: {
                                  normal: { color: '#00fcff' }
                              },
                              x:c<=0.5?(8+c*56).toFixed(2)+"%":c<=1?(37+c*28).toFixed(2)+"%":(65+c*0.3).toFixed(2)+"%",
                              y: '56.8%',
                              label: {
                                  normal: {
                                      show: true,
                                      formatter:c+"%",
                                      offset:[c>=97?-30:0,-19],
                                      color:'#fff',
                                      fontSize:this.$echartsFontSize, 
                                      fontWeight:600
                                  }
                              },
                          },
                          {
                            name:'煤碳',
                              symbol: 'triangle',
                              symbolSize: this.$echartsFontSize,
                              symbolRotate: 0,//剪头方向
                              // symbolOffset:[d>=50?-70:70,0],
                              // symbolOffset:[20,0],
                              itemStyle: {
                                  normal: {
                                      color: '#00fcff'
                                  }
                              },
                              x:d<=2?(8+d*14.5).toFixed(2)+"%":d<=5?(37+d*5.6).toFixed(2)+"%":(65+d*0.3).toFixed(2)+"%",
                              y: '75.5%',
                              label: {
                                  normal: {
                                      show: true,
                                      formatter:d+"%",
                                      offset:[d>=97?-30:0,-19],
                                      color:'#fff',
                                      fontSize:this.$echartsFontSize, 
                                      fontWeight:600
                                  }
                              },
                          },
                          {
                              name:'燃油',
                              symbol: 'triangle',
                              symbolSize: this.$echartsFontSize,
                              symbolRotate: 0,//剪头方向
                              // symbolOffset:[e>=50?-70:70,0],
                              // symbolOffset:[20,0],
                              itemStyle: {
                                  normal: {
                                      color: '#00fcff'
                                  }
                              },
                              x:e<=2?(8+e*14.5).toFixed(2)+"%":e<=5?(37+e*5.6).toFixed(2)+"%":(65+e*0.3).toFixed(2)+"%",
                              y: '93.5%',
                              label: {                               
                                  normal: {
                                      show: true,
                                      formatter:e+"%",
                                      offset:[e>=97?-30:0,-19],
                                      color:'#fff',
                                      fontSize:this.$echartsFontSize, 
                                      fontWeight:600
                                  }
                              },
                          }
                      ]
                  }
              }
              
          ]
      })
    },
    
  },
  mounted() {
    this.getList()
    // this.$nextTick(()=>{
    //   this.ec_bar1();
    // })
    // for(var i=0;i<this.shdata.length;i++){
    //   var sum=this.shdata[i].min+this.shdata[i].max;
    //   var w=(this.shdata[i].min/sum*100).toFixed(0)
    //   var l=(this.shdata[i].value/sum*100).toFixed(0)
    //   this.shdata[i].minw=w;
    //   this.shdata[i].maxw=w;
    //   this.shdata[i].valueleft=l;
    //   if(this.shdata[i].value<=this.shdata[i].min){
    //     this.shdata[i].text='优秀'
    //   }else if(this.shdata[i].value>this.shdata[i].min && this.shdata[i].value<=this.shdata[i].max){
    //     this.shdata[i].text='良好'
    //   }else{
    //     this.shdata[i].text='较差'
    //   }
    // }
  },
};
</script>

<style lang="less" scoped>
.ec{ width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;
  #ec_bar1{ height: 100%; width: 100%;}
  .ectitle{ height: 1.2rem; display: flex; flex-direction: row; width: 100%; align-items: flex-end;
    span:nth-child(1){ width: 20%; text-align: center; margin-left: 4rem;}
    span:nth-child(2){ flex: 1; text-align: center;}
    span:nth-child(3){ width: 20%; text-align: center; margin-right: 3rem;}
  }
  .eclist{ flex: 1; height: 100%; width: 100%; padding-right: 1rem; display: flex; flex-direction: row; align-items: center;
    &>span{ width: 4rem; text-align: right; padding-right: 10px; flex-shrink: 0;}
    &>div{ width: 100%; flex: 1; display: flex; flex-direction: row; position: relative; background: #00ccff; height: .8rem; justify-content: space-between;
      .num{ position: absolute; z-index: 3; width: 1rem; text-align: center; font-weight: bold; color: #042097; text-shadow: #fff 0 0 3px;}
      .num::after{ content: ' '; position: absolute; left: -1px; top: .28rem; width: 0; height: 0; border-width: .5rem; border-style: solid; border-color: transparent transparent #00ccff transparent; transform: scaleX(.8);}
      .di{ background: #24ffb1;}
      .gao{ background: #f4af1b;}
    }
    &>span:last-child{ width: 1.8rem; padding-right: 0;}
  }
}
</style>